import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from 'kea-resource';

import { Camion } from "./camion";
import { Guia } from "./guia";
import { CajaRuta } from "./cajaruta";

const controller = rpcController("EntregaIngresos");
const crud = rpcCrudService<models.EntregaIngresosAUsuario, models.EntregaIngresosAUsuarioDto>(controller);

import { SaldosUsuariosZE } from "./saldousuariosze";

export const EntregaIngresosZE = cacheResource({
    ...crud,
    /**Proceso de cancelación de entrega de ingreso */
    CancelarEntregaIngreso: async (idEntregaIngreso: number, motivo: string): Promise<boolean> =>
    await controller('CancelarEntregaIngreso', { idEntregaIngreso, motivo }),

    /**Genera un reporte de entrega de ingresos a usuario ZE */
    GenerarReporte: async (idEntregaIngreso: number): Promise<string> => await controller('GenerarReporte', { idEntregaIngreso }),

}, {

    }, {
        CancelarEntregaIngreso: true
    });

addOnInvalidateHandler(EntregaIngresosZE, () => invalidateResource(SaldosUsuariosZE)); 


// WEBPACK FOOTER //
// ./app/resources/items/entregaingresosZE.tsx